export enum RosterUploadFileType {
  Automatic = 0,
  Manual = 1,
  GroupOfGroups = 2,
  External = 3
}
